import React from "react";
import "./TrainersItem.sass"
import {useNavigate} from "react-router";
import PropTypes from "prop-types";

export default function TrainersItem({Icon, title, link, disabled = false}) {
    const navigate = useNavigate();

    return (
        <div className={`TrainersItem-wrapper ${disabled && "TrainersItem-wrapper-disabled"}`}
             onClick={disabled ? () => {} : () => navigate(link)}>
            <div className="TrainersItem-icon">
                <Icon/>
            </div>
            <div className="TrainersItem-title">
                <span>{title}</span>
            </div>
        </div>
    )
}

TrainersItem.propTypes = {
    title: PropTypes.string.isRequired,
    link: PropTypes.string.isRequired,
    Icon: PropTypes.object.isRequired,
}